import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from '../dashboard.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';

@Component({
  selector: 'app-confirmation-box',
  templateUrl: './confirmation-box.component.html',
  styleUrls: ['./confirmation-box.component.scss']
})
export class ConfirmationBoxComponent implements OnInit {

  constructor( public dialogRef: MatDialogRef<ConfirmationBoxComponent>,
    public dashboardService: DashboardService,
    public opdvisitService: OpdVisitService) { }

  ngOnInit() {
  }
 
  deletepatient(){
    this.opdvisitService.delete_patient(); 
    this.dialogRef.close();
  }
close(){
  this.dashboardService.popup_cancel = true;
  this.dialogRef.close();
}

}
